(function () {
  "use strict";

  angular
    .module("alk.maps")
    .directive("mapStyles", mapStyles);

  function mapStyles() {

    var directive = {
      bindToController: true,
      controller: mapSylesController,
      controllerAs: "vm",
      template: require("./mapStylesMenu.html"),
      restrict: "E",
      scope: {}
    };
    return directive;

  }

  mapSylesController.$inject = ["$scope", "$element", "$attrs", "$translate", "mapService"];

  function mapSylesController($scope, $element, $attrs, $translate, mapService) {

    var vm = this;

    var mapStyles = [{
        name: "Road Map",
        style: "transportation",
        img: require("../../../Common Style Files/img/mapstyle-default.svg")
      },
      {
        name: "Satellite Map",
        style: "satellite",
        img: require("../../../Common Style Files/img/mapstyle-satellite-roads.svg")
      },
      {
        name: "Satellite Only",
        style: "satellite_only",
        img: require("../../../Common Style Files/img/mapstyle-satellite-only.svg")
      },
      {
        name: "Terrain Map",
        style: "terrain",
        img: require("../../../Common Style Files/img/mapstyle-terrain.svg")
      },
      {
        name: "Light Data Map",
        style: "datalight",
        img: require("../../../Common Style Files/img/mapstyle-monochrome.svg")
      },
      {
        name: "Dark Data Map",
        style: "datadark",
        img: require("../../../Common Style Files/img/mapstyle-contemporary.svg")
      }
      // {
      //   name: "Trimble Map",
      //   style: "classic",
      //   img: require("../../../Common Style Files/img/mapstyle-default.svg")
      // },
    ];

    function filterStyles() {
      if ($attrs && $attrs.exclude) {
        var exList = $attrs.exclude.split(",");
        var exStyles = _.filter(mapStyles, function (s) {
          var isExcluded = exList.indexOf(s.style) === -1;
          return isExcluded;
        });
        return exStyles;
      } else {
        return mapStyles;
      }
    }

    vm.includedMapStyles = filterStyles();

    vm.changeMapStyle = mapService.setStyle;

    vm.isStyle = function (style) {
      return (style === mapService.getStyle());
    };

    vm.currentMapStyle = function () {
      var currentStyle = mapService.getStyle();
      return _.find(mapStyles, function (s) {
        return s.style === currentStyle;
      });
    };

  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-maps/mapStyleMenu.directive.js